import Slider from './_slider';

const sliderElements = [...document.querySelectorAll('.js-slider')];

sliderElements.map(sliderElement => {
    const slider = new Slider(sliderElement, {
        arrows: sliderElement.hasAttribute('data-arrows'),
        dots: sliderElement.hasAttribute('data-dots'),
        autoplay: sliderElement.hasAttribute('data-autoplay')
    });

    const thumbnailsContainer = sliderElement.querySelector('.js-slider-thumbs-container');

    if(thumbnailsContainer) {
        const thumbnails = [...thumbnailsContainer.querySelectorAll('.js-slider-thumb')];

        thumbnails.map((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                slider.goToSlide(index);
            })
        });

        slider.on('change', currentSlide => {
            updateActiveThumnbail(currentSlide);
        });

        const updateActiveThumnbail = newIndex => {
            thumbnails.map((thumbnail, index) => {
                if (index === newIndex) {
                    const {offsetLeft} = thumbnail;
                    thumbnail.setAttribute('data-active', '');

                    thumbnailsContainer.scrollTo({left: offsetLeft, behavior: 'smooth'});
                } else {
                    thumbnail.removeAttribute('data-active');
                }
            });
        }
    }

    sliderElement.addEventListener('slider.goToSlide', e => {
        slider.goToSlide(e.detail.slideIndex, false, false);
    });


});


